'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _adsReducer = require('./ads-reducer');

var _adsReducer2 = _interopRequireDefault(_adsReducer);

var _pageReducer = require('./page-reducer');

var _pageReducer2 = _interopRequireDefault(_pageReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  dfpAds: _adsReducer2.default,
  page: _pageReducer2.default
});


//////////////////
// WEBPACK FOOTER
// ./~/@univision/fe-commons/dist/store/reducers/index.js
// module id = 284
// module chunks = 35783957827783